import { DraggableTypesEnum } from 'constants/builder/enums';

import type { QuestionnaireItems } from '../types';

export const deleteClauseVariationsHelper = (questions: QuestionnaireItems, clauseId: string) => {
    const itemForDelete = questions.find(
        question => question.clauseId === clauseId && question.questionType === DraggableTypesEnum.Clause
    );

    return questions
        .filter(item => item.id !== itemForDelete?.id)
        .map(question => {
            if (question.clauseId === clauseId) {
                return {
                    ...question,
                    isShown: true
                };
            }

            return question;
        });
};
